import React from 'react';

const About = () => {
  return (
    <div className="about-area section-padding bg-gray">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6 info">
            <div className="about-wrapper">
              <div className="site-heading lang-en">
                <p className="mb-3">Manage Statistics</p>
                <h2 className="section-title">Detailed Insights of Your Buffet System</h2>
                <div className="content">
                  <p>Track employee drink requests, used points, favorites and stock movements from a single cloud dashboard. Each company has its own subdomain, real-time kitchen orders, and admin reports for spending & rewards.</p>
                  {/* <a href="#pricing" className="btn btn-common mt-3">View Dashboard</a> */}
                </div>
              </div>

              <div className="site-heading lang-ar" style={{ display: 'none' }}>
                <p className="mb-3">إدارة الإحصائيات</p>
                <h2 className="section-title">إحصائيات دقيقة لنظام البوفية</h2>
                <div className="content">
                  <p>تتبع طلبات المشروبات من الموظفين، النقاط المستخدمة، المفضلات، وحركة المخزون كل ذلك من لوحة تحكم سحابية واحدة. كل شركة تحصل على نطاق فرعي، الطلبات تصل للمطبخ فورياً، والمدير يطلع تقارير عن المصروفات واستخدام النقاط.</p>
                  {/* <a href="#pricing" className="btn btn-common mt-3">عرض لوحة التحكم</a> */}
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-6 text-center">
            <img className="img-fluid" src={require('../assets/img/about/img-1.png')} alt="Dashboard preview" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
